import CustomTextInput from "../../../components/Input/Text/TextInput";
import classes from "./Education.module.css";
import CustomSelecter from "../../../components/Input/Autocomplete/Autocomplete";
import WorkExperience from "../Experience/WorkExperience";
import Language from "../Languages/Languages";
import ComputerProgram from "../ComputerProgram/ComputerProgram";
import CustomRadioButton from "../../../components/Input/RadioButton/RadioButton";
import { extraQuestionOptions } from "../../../DummyData/DUMMYDATA";
import { useTranslation } from "../../../I18n/Languages/LanguageContext";
import { getEducation } from "../../../utils/translatedOptions";
import YearPicker from "../../../components/Input/Year";

export default function EducationForm({
  workExperience,
  updateWorkExperienceEntry,
  addWorkExperienceEntry,
  removeWorkExperienceEntry,
  languages,
  updateLanguageEntry,
  addLanguageEntry,
  removeLanguageEntry,
  computerPrograms,
  setComputerPrograms,
  computerSkillsData,
  setComputerSkillsData,
  formData,
  updateFormData,
  isWorkForce,
}) {
  const { t } = useTranslation();
  return (
    <>
      <div className={classes.personalForm}>
        <div className={classes.firstGroup}>
          <div style={{ width: "100%" }}>
            <CustomSelecter
              width="100%"
              topLabel={t("highest_education_level")}
              label={t("select_education")}
              options={getEducation(t)}
              value={formData.educationHighestLevel}
              onChange={(value) =>
                updateFormData("educationHighestLevel", value)
              }
            />
          </div>
          <CustomTextInput
            name="educationInstitutionName"
            topLabel={t("institution_name")}
            label={t("institution_name")}
            maxLength={100}
            value={formData.educationInstitutionName}
            onChange={(e) =>
              updateFormData("educationInstitutionName", e.target.value)
            }
          />
        </div>
        <div className={classes.firstGroup}>
          <CustomTextInput
            label={t("field_of_study")}
            name="educationFieldOfStudy"
            maxLength={100}
            value={formData.educationFieldOfStudy}
            topLabel={t("field_of_study")}
            onChange={(e) =>
              updateFormData("educationFieldOfStudy", e.target.value)
            }
          />
          <YearPicker
            value={formData.educationGraduationYearEnd}
            onChange={(val) =>
              updateFormData("educationGraduationYearEnd", val)
            }
            topLabel={t("graduation_year")}
          />
        </div>
        <CustomTextInput
          label={t("additional_certifications")}
          name="educationAdditionalCertifications"
          maxLength={200}
          value={formData.educationAdditionalCertifications}
          onChange={(e) =>
            updateFormData("educationAdditionalCertifications", e.target.value)
          }
          topLabel={t("certifications_placeholder")}
        />
      </div>
      <div className={classes.divider} />
      <WorkExperience
        workExperience={workExperience}
        updateWorkExperienceEntry={updateWorkExperienceEntry}
        addWorkExperienceEntry={addWorkExperienceEntry}
        removeWorkExperienceEntry={removeWorkExperienceEntry}
      />
      {isWorkForce === false && (
        <>
          <div className={classes.divider} />
          <Language
            languages={languages}
            updateLanguageEntry={updateLanguageEntry}
            addLanguageEntry={addLanguageEntry}
            removeLanguageEntry={removeLanguageEntry}
          />
        </>
      )}
      {isWorkForce === false && (
        <>
          <div className={classes.divider} />
          <ComputerProgram
            computerPrograms={computerPrograms}
            setComputerPrograms={setComputerPrograms}
            formData={formData}
            updateFormData={updateFormData}
            computerSkillsData={computerSkillsData}
            setComputerSkillsData={setComputerSkillsData}
          />
        </>
      )}
      {isWorkForce === false && (
        <div className={classes.mobile}>

          <CustomRadioButton
            name="additionalQuestions"
            topLabel={t("driving_license_question")}
            options={extraQuestionOptions}
            value={formData.drivingLicense}
            onChange={(e) => updateFormData("drivingLicense", e.target.value)}
          />
        </div>
      )}
    </>
  );
}
